import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import Store from '../context'
import * as Routes from '../constants/routes'

import Loader from '../components/advanced/loader'
import { Popup } from '../components/advanced/popup'
import WithEventListeners from '../context/witheventlisteners'

import HomePage from '../pages/home'
import DocsPage from '../pages/docs'

import { Page } from '../components/basic/layout'
import { AppData } from '../data'
import GAStore from '../context/googleAnalytics'
import {ErrorBoundary} from 'react-error-boundary'
import ErrorFallback from '../errorFallback'

const App = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
    <Store>
      <WithEventListeners>
        <Router>
          <Loader />
          <Popup />
          <Page>
            <Switch>
              <Route path={Routes.DOCS}>
                <DocsPage />
              </Route>
              <Route path={Routes.HOME}>
                <GAStore>
                  <HomePage appData={AppData} />
                </GAStore>
              </Route>
            </Switch>
          </Page>
        </Router>
      </WithEventListeners>
    </Store>
    </ErrorBoundary>
  )
}

export default App
